import type { SyntheticEvent } from 'react';

export function filterKeyEnter(handler: any) {
  return (e: any) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
      handler(e);
    }
  };
}

export function accessibleOnClick(
  handler: (event?: SyntheticEvent) => void,
  role = 'button',
  tabIndex = 0,
  ariaLabel?: string,
) {
  return {
    role,
    tabIndex,
    onKeyDown: filterKeyEnter(handler),
    onClick: handler,
    'aria-label': ariaLabel,
  };
}
